/**
 * Base Resource Service with common READ operations (Public Routes Only)
 * Provides standard REST read operations that can be extended by specific services
 *
 * NOTE: Write operations (create, update, patch, delete) are removed as they require authentication
 */
export class BaseResourceService {
  constructor(httpClient, resourcePath) {
    this.client = httpClient;
    this.path = resourcePath;
  }

  /**
   * Get all resources with optional filtering (PUBLIC)
   */
  async getAll(params = {}) {
    return this.client.get(this.path, params);
  }

  /**
   * Get a single resource by ID (PUBLIC)
   */
  async getById(id) {
    return this.client.get(`${this.path}/${id}`);
  }

  /**
   * Get paginated results (PUBLIC)
   */
  async getPaginated(page = 1, limit = 10, filters = {}) {
    const params = {
      page,
      limit,
      ...filters
    };
    return this.client.get(this.path, params);
  }

  /**
   * Search resources (PUBLIC)
   */
  async search(query, filters = {}) {
    const params = {
      search: query,
      ...filters
    };
    return this.client.get(this.path, params);
  }

  // NOTE: The following methods are removed as they require authentication:
  // - create() - requires write permission
  // - update() - requires write permission
  // - patch() - requires write permission
  // - delete() - requires write permission
}